const article = (value) => String(value ?? "").trim().toLowerCase();
const trace = (value) => String(value ?? "").trim().toLowerCase();

export function matchArticleIngredient(item, rawMaterials, helpers) {
  const code = article(item.artikelnummer || item.artikelnr);
  if (!code) return null;
  const raw = rawMaterials.filter((m) => article(m.artikelnummer || m.artikelnr) === code);
  const aux = helpers.filter((m) => article(m.artikelnr || m.artikelnummer) === code);
  const matches = [...raw.map((m) => ({ categorie: "Grondstof", ...m })), ...aux.map((m) => ({ categorie: "Hulpstof", ...m }))];
  if (new Set(matches.map((m) => `${m.categorie}|${m.naam}`)).size !== 1) return null;
  const m = matches[0];
  return { categorie: m.categorie, naam: m.naam, prijs: Number(m.prijs) || 0 };
}

export function matchRawScanBatch(item, rawMaterials, helpers, expeditie) {
  const canonical = matchArticleIngredient(item, rawMaterials, helpers);
  if (canonical?.categorie === "Hulpstof" || item.categorie === "Hulpstof") return null;
  const name = canonical?.naam || item.naam;
  const code = trace(item.partijnummer || item.batchnr || item.eigenTracecode);
  if (!name || !code) return null;
  const candidates = expeditie.filter((b) => b.grondstof === name && (!b.type || b.type === "Grondstof") && (trace(b.batchnr) === code || trace(b.eigenTracecode) === code));
  return candidates.length === 1 ? candidates[0] : null;
}
